/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LoginType {
    GOOGLE = 'Google',
    FACEBOOK = 'Facebook',
}
